import { TextField } from "@mui/material"
import React from "react"
import Autocomplete from "@mui/material/Autocomplete"
import feature_schema from "../../configs/feature_schema.json"

const Search = ({ map_ref, fac_geo_json, cup_geo_json }) => {
  const [value, setValue] = React.useState(null)

  const extract_points = (geojson) => {
    if (!geojson || !geojson.features) {
      return []
    }

    const points = geojson.features.map((feature) => {
      return {
        name: feature.properties[feature_schema.facility.name_property],
        coordinates: feature.geometry.coordinates,
      }
    })
    return points
  }

  if (!fac_geo_json) {
    return null
  }

  const facility_points = extract_points({
    type: "FeatureCollection",
    features: fac_geo_json.features.filter(
      (feature) => feature.properties.type !== "gp",
    ),
  })
  const cups_points = extract_points(cup_geo_json)

  let points = [...facility_points, ...cups_points]

  points = points.filter(
    (point, index, self) =>
      index === self.findIndex((t) => t.name === point.name),
  )

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue)
        if (!newValue) {
          return
        }
        const facility = points.find((feature) => {
          return feature.name === newValue
        })
        const { coordinates } = facility
        map_ref?.flyTo({ center: coordinates, duration: 2000 })
      }}
      options={points.map((feature, i) => {
        return feature.name
      })}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Find Facility"
          margin="dense"
          variant="standard"
        />
      )}
    />
  )
}

export default Search
